
export default {
  props: {
    visible: {type: Boolean, default: false},
    generating: {type: Boolean, default: false}
  },
  emits: ['scroll']
}
